import type { TFunction } from 'i18next'

/**
 * Calls t() for keys that contain {{interpolation}} variables.
 *
 * i18next v23's TypeScript overload resolution breaks when a cross-namespace
 * key ('ns:key') is combined with an options object — it picks the wrong
 * overload and errors on the options argument. This is the single place
 * that cast lives; regular t() calls remain fully typed.
 */
export const tVar = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: TFunction<any>,
  key: string,
  vars: Record<string, unknown>
): string => t(key as never, vars as never) as unknown as string
